import { observer } from 'mobx-react'
import { makeStyles, Theme, createStyles, InputAdornment, MenuItem } from "@material-ui/core";
import { SelectProps as MUISelectProps } from "@material-ui/core";
import { ForwardedRef, forwardRef, useState } from 'react';
import REMSelect from '../../rem-conversion/components/Select';
import MdiIcon from '../../../../components/Shared/MdiIcon';
import { mdiMapClockOutline } from '@mdi/js';
import { getTimeZoneNameMapping } from '../../../../logic/TimeZones';
import { sortRecordAlphabetically } from '../../../../logic/Alphabetizing';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            padding: theme.spacing(1),
            color: 'rgba(0, 0, 0, 0.54)'
        },
    })
);

interface TimeZoneSelectProps extends MUISelectProps {
    value: string | 0;
    onChange: (event: React.ChangeEvent<{
        name?: string;
        value: unknown;
    }>, child: React.ReactNode) => void;
    hideUnselectedOption?: boolean;
}

const TimeZoneSelect = observer(forwardRef((props: TimeZoneSelectProps, ref: ForwardedRef<HTMLElement>) => {

    /********* React hooks *********/

    const classes = useStyles();

    const [timeZoneMapping] = useState(sortRecordAlphabetically(getTimeZoneNameMapping()));

    /********* Render *********/

    return (
        <REMSelect
            {...props}
            ref={ref}
            value={props.value}
            onChange={props.onChange}
            startAdornment={
                <InputAdornment position="start" className={classes.icon}>
                    <MdiIcon iconPath={mdiMapClockOutline} />
                </InputAdornment>
            }
        >
            {props.hideUnselectedOption
                ? null
                : <MenuItem value={0}>
                    Select a Time Zone
                </MenuItem>
            }
            {Object.keys(timeZoneMapping).map((timeZoneName) => {
                const timeZones = timeZoneMapping[timeZoneName];
                return timeZones.map((timeZone, index) => {
                    return (
                        <MenuItem key={`timezone-${timeZoneName}-${index}`} value={timeZone}>
                            {timeZoneName + " - " + timeZone.replaceAll("_", " ")}
                        </MenuItem>
                    );
                })
            })}
        </REMSelect>
    );
}));

export default TimeZoneSelect;